// extracted by mini-css-extract-plugin
module.exports = {"header-section":"header-section_header-section__ZY_r8"};